import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    isCreatingPostFire: false,
    isCreatingPostFireProject: false,
    showMap: true,
    isNewFeature: false,
    /* Handles state tracking for BulkEdit component parent and sibling cell edits */
    subRowEditedCells: {
        existingRow: [],
        newRow: [],
        changesSavedToParent: true, // Flag used to block re-setting existing values on multiple sibling edits
    },
    parentRowEditedCells: {
        existingRow: {},
        newRow: {},
    },
    isApproved: false,
    isCreatingPlannedFeature: false,
    headerHeight: 120,
    listCheckedFeatures: []
};

export const displayStateSlice = createSlice({
    name: 'displayState',
    initialState,
    reducers: {
        setIsCreatingPostFire: (state, action) => {
            state.isCreatingPostFire = action.payload;
        },
        setIsCreatingPostFireProject: (state, action) => {
            state.isCreatingPostFireProject = action.payload;
        },
        setShowMap: (state, action) => {
            state.showMap = action.payload;
        },
        setIsNewFeature: (state, action) => {
            state.isNewFeature = action.payload;
        },
        setSubRowEditedCells: (state, action) => {
            state.subRowEditedCells = action.payload;
        },
        setParentRowEditedCells: (state, action) => {
            state.parentRowEditedCells = action.payload;
        },
        setIsApproved: (state, action) => {
            state.isApproved = action.payload;
        },
        setIsCreatingPlannedFeature: (state, action) => {
            state.isCreatingPlannedFeature = action.payload;
        },
        setHeaderHeight: (state, action) => {
            state.headerHeight = action.payload;
        },
        setListCheckedFeatures: (state, action) => {
            state.listCheckedFeatures = action.payload;
        },
    },
});

export const {
    setIsCreatingPostFire,
    setIsCreatingPostFireProject,
    setShowMap,
    setIsNewFeature,
    setSubRowEditedCells,
    setParentRowEditedCells,
    setIsApproved,
    setIsCreatingPlannedFeature,
    setHeaderHeight,
    setListCheckedFeatures,
} = displayStateSlice.actions;

export default displayStateSlice.reducer;
